module.exports = __webpack_public_path__ + "static/media/2.bc1efb25.png";